import { render, staticRenderFns } from "./list-product-slide.vue?vue&type=template&id=7bf6c11e&scoped=true"
import script from "./list-product-slide.vue?vue&type=script&lang=js"
export * from "./list-product-slide.vue?vue&type=script&lang=js"
import style0 from "./list-product-slide.vue?vue&type=style&index=0&id=7bf6c11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf6c11e",
  null
  
)

export default component.exports